import { ApplicationState } from '@/platform/ApplicationState';
import { IActions } from './IActions';
import { IGetters } from './IGetters';
import { IMutations } from './IMutations';
import { VisaPresenter } from '@/presenters/VisaPresenter';

export class Actions implements IActions {
	private readonly getters: IGetters;
	private readonly mutations: IMutations;

	public constructor(getters: IGetters, mutations: IMutations) {
		this.getters = getters;
		this.mutations = mutations;
	}

	public async loadVisa(): Promise<void> {
		const idOfOriginCountry = this.getters.getOriginCountryId();
		const idOfDestinationCountry = this.getters.getDestinationCountryId();

		if (idOfOriginCountry === null || idOfDestinationCountry === null) {
			return;
		}

		this.mutations.setApplicationState(ApplicationState.LOADING);

		try {
			const visa = await VisaPresenter.retrieve(idOfOriginCountry, idOfDestinationCountry);

			this.mutations.setVisa(visa);
			this.mutations.setApplicationState(ApplicationState.READY);
		} catch (e) {
			this.mutations.setVisa(null);
			this.mutations.setApplicationState(ApplicationState.ERROR);

			throw e;
		}
	}

	public async changeOriginCountry(originCountryId: string | null): Promise<void> {
		if (this.getters.getOriginCountryId() === originCountryId) {
			return;
		}

		this.mutations.setOriginCountryId(originCountryId);
		await this.loadVisa();
	}

	public async changeDestinationCountry(destinationCountryId: string | null): Promise<void> {
		if (this.getters.getDestinationCountryId() === destinationCountryId) {
			return;
		}

		this.mutations.setDestinationCountryId(destinationCountryId);
		await this.loadVisa();
	}

	public openLocalizationSettings(): void {
		document.dispatchEvent(new Event('open_localization_settings'));
	}
}
